// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import {
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBNavLink,
  MDBRow,
} from 'mdbreact';
import { connect } from 'react-redux';
import TemplateRow from './templateRow';
import getTemplatesList from '../../utils/api/get/getTemplatesList';
import { toggleModal } from '../../storage/actions/modalsActions';
import {
  renameWorkOrderTemplate,
  deleteWorkOrderTemplate,
  copyWorkOrderTemplate,
} from '../../storage/actions/workOrdersActions';
import {Link} from "react-router-dom";

const Content = ({
  isReload,
  toggleModal,
  renameWorkOrderTemplate,
  deleteWorkOrderTemplate,
  copyWorkOrderTemplate,
}) => {
  const [templates, setTemplates] = useState([]);

  const fetchTemplatesList = async () => {
    toggleModal(true, 'loader');
    const newTemplatesList = await getTemplatesList();
    setTemplates(newTemplatesList);
    toggleModal(false, 'loader');
  };

  useEffect(() => {
    fetchTemplatesList();
  }, [isReload]);

  const handlerCopy = templateId => {
    const saveCopy = name => {
      copyWorkOrderTemplate(name, templateId);
    };
    toggleModal(true, 'confirmModal', true, {
      onAccept: saveCopy,
      header: 'Copy template',
      inputLabel: 'Name',
      buttonLabels: { reject: 'Cancel' },
    });
  };

  const handlerDelete = templateId => {
    toggleModal(true, 'confirmModal', true, {
      onAccept: () => deleteWorkOrderTemplate(templateId),
      header: 'Are you sure you want to delete this template?',
      buttonLabels: { reject: 'Cancel' },
    });
  };

  return (
    <>
        <table className="subpage-table">

        <thead>
            <tr>
                <th className="name">Template Name</th>
                <th className="actions-col">Action</th>
            </tr>
          </thead>
            {
            templates?.map(template => (
              <TemplateRow
                key={template.value}
                template={template}
                deleteTemplate={handlerDelete}
                rename={renameWorkOrderTemplate}
                copyTemplate={handlerCopy}
              />
            ))
          }
        </table>

    </>
  );
};

const mapDispatchToProps = {
  toggleModal,
  renameWorkOrderTemplate,
  deleteWorkOrderTemplate,
  copyWorkOrderTemplate,
};

const mapStateToProps = state => ({
  isReload: state.applicationState.isReload,
});

export default connect(mapStateToProps, mapDispatchToProps)(Content);
